import { render, staticRenderFns } from "./B2bsalesrepresentatives.vue?vue&type=template&id=61cf4672&scoped=true&"
import script from "./B2bsalesrepresentatives.vue?vue&type=script&lang=js&"
export * from "./B2bsalesrepresentatives.vue?vue&type=script&lang=js&"
import style0 from "./B2bsalesrepresentatives.vue?vue&type=style&index=0&id=61cf4672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf4672",
  null
  
)

export default component.exports